import { getI18n } from "react-i18next";

export const getViewPort = () => {
  return {
    width: window.innerWidth,
    height: window.innerHeight,
  };
};

export const getBreakpoint = (mode: "sm" | "md" | "lg" | "xl") => {
  const breakpoints = {
    sm: 544, // Small screen / phone
    md: 768, // Medium screen / tablet
    lg: 992, // Large screen / desktop
    xl: 1200, // Extra large screen / wide desktop
  };
  return breakpoints[mode];
};

export function getIdTypeOptions(idTypeConfig: any) {
  if (!idTypeConfig) {
    return { options: [], default: "" };
  }
  let defaultKey = "";
  const options = Object.keys(idTypeConfig).map((key, index) => {
    const option = idTypeConfig[key];
    if (option.isDefault) {
      defaultKey = option.value;
    }
    return {
      text: getI18n().t(`Common.${key}`),
      value: option.value,
    };
  });
  return { options, default: defaultKey };
}
